<template>
  <div class="row mt-3 mb-5">
    <div class="col-lg-6 col-md-12 pl-3 banner-container d-flex align-items-center">
      <vue-aspect-ratio ar="16:9" width="100%">
        <div class="text-center front-banner flex-grow-1 h-100">
          <div style="background-image: url(static/img/home/books.jpg)" class="hero-image">
            <div class="mx-auto mt-auto h-100 d-flex flex-column justify-content-center">
              <div class="text-center h-100 d-flex flex-column justify-content-center white-bg">
                <b-img :src="isRTL ? '/static/hadaf-logo.svg' : '/static/logo.png'" alt="Shas Illuminated" class="brand-logo img-fluid" />
                <h3 v-if="!isRTL" class="text-blue font-weight-bold">
                  {{ $_t('KW:site.title') }}
                </h3>
                <h5 class="text-blue mt-2 mb-1">
                  {{ $_t('KW:site.subtitle') }}
                </h5>
                <h5 class="text-blue">{{ $_t('KW:site.tagline') }}</h5>
                <h5 v-if="isRTL" class="text-blue mt-4">לע"נ שמריהו בן חיים ואסתר מרים בת אבא הכהן</h5>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-grow-1">
              <router-link v-if="dafLink" :to="dafLink">
                <b-btn variant="secondary" class="py-3 px-4 left-rounded h-100">{{ $_t('KW:todayDaf') }}</b-btn>
              </router-link>
            </div>
            <div class="flex-grow-1">
              <router-link to="/magidei-shiur">
                <b-btn variant="secondary" class="py-3 px-4 h-100">{{ $_t('KW:magideiShiur') }}</b-btn>
              </router-link>
            </div>
            <div class="flex-grow-1">
              <router-link to="/masechtos">
                <b-btn variant="secondary" class="py-3 px-4 right-rounded h-100">{{ $_t('KW:selectMasechta') }}</b-btn>
              </router-link>
            </div>
          </div>
        </div>
      </vue-aspect-ratio>
    </div>
    <div class="col-lg-6 col-md-12 mt-sm-4 mt-lg-0 carousel-container">
      <vue-aspect-ratio ar="16:9" width="100%">
        <carousel :loop="true" :autoplay="carouselPlay" :scrollPerPage="false" navigationEnabled :perPage="1" :paginationEnabled="false" class="h-100">
          <slide v-for="(element, index) in cmsData" :key="index" class="h-100">
            <div class="carousel-element h-100" v-if="element.type == 'video'">
              <jwvideo @video-play-event="videoPlayed" :link="element.video_url" :image="element.video_thumbnail" :playerId="'video-player-' + index"></jwvideo>
            </div>
            <div class="carousel-element h-100" v-if="element.type == 'image'">
              <a :href="element.redirect_url" target="_blank" class="h-100">
                <b-img class="h-100" :src="element.photo_url" fluid />
              </a>
            </div>
          </slide>
        </carousel>
      </vue-aspect-ratio>
    </div>
  </div>
</template>

<script>
import video from './Video';
import { Carousel, Slide } from 'vue-carousel';
import VueAspectRatio from 'vue-aspect-ratio';
import { mapGetters } from 'vuex';

export default {
  data: function () {
    return {
      cmsData: null,
      carouselPlay: true,
    };
  },
  components: {
    Carousel: Carousel,
    Slide: Slide,
    jwvideo: video,
    'vue-aspect-ratio': VueAspectRatio,
  },
  computed: {
    ...mapGetters({ daf: 'api/daf' }),
    dafLink() {
      if (!this.daf || !this.daf.masechta) return;

      return '/shiur/masechta-' + this.daf.masechta.url_key + '/daf-' + this.daf.daf;
    },
  },
  created: function () {
    this.$http.get('/api/home-carousel').then(response => {
      this.cmsData = response.data.content;
    });
  },
  methods: {
    videoPlayed() {
      this.carouselPlay = false;
    },
  },
};
</script>

<style lang="scss">
.carousel-container {
  @media (max-width: 578px) {
    margin-top: 20px !important;
  }
  @media (max-width: 450px) {
    margin-top: 40px !important;
  }
  @media (max-width: 420px) {
    margin-top: 60px !important;
  }
  @media (max-width: 380px) {
    margin-top: 100px !important;
  }
}
.carousel-element {
  a {
    background: black;
    display: flex;
    img {
      margin: auto 0;
      // height: 400px !important;
      // width: 784px !important;
    }
  }

  .video-container .jwplayer {
    height: 100% !important;
  }
}
.front-banner {
  .white-bg {
    background: rgba(255, 255, 255, 0.75);
    .brand-logo {
      height: 120px;
      margin: 0 auto 20px auto;
      @media (max-width: 1200px) {
        height: 100px !important;
      }
      @media (max-width: 992px) {
        height: 75px !important;
      }
    }
  }

  display: flex;
  flex-direction: column;
  .hero-image {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    flex-grow: 1;
  }
  button {
    background: $dark-blue;
    border: $dark-blue;
    border-radius: 0;
    width: 100%;
    // font-weight: bold;
    font-size: 1.05rem;
    color: $white;
    &:hover {
      background: $secondary;
      color: $dark-blue;
    }
  }
  button.left-rounded {
    border-radius: 0 0 0 5px;
  }
  button.right-rounded {
    border-radius: 0 0 5px 0;
  }
}
.VueCarousel-navigation {
  @media (max-width: 768px) {
    position: relative;
    .VueCarousel-navigation-button {
      position: absolute;
      margin-left: 10% !important;
      margin-right: 10% !important;
      bottom: 0;
      font-size: 1.5rem;

      &:active,
      &:focus {
        outline: none;
      }
    }
  }
}
.VueCarousel-wrapper,
.VueCarousel-inner {
  height: 100% !important;
}
</style>
